import { Avatar, Button,  Divider, RichTextReader, Stack, Typography } from "@compass/core";
import { Comment } from "generated/openApi";
import { useDateTime } from "hooks";
import { useState } from "react";
import { useSelector } from "react-redux";
import { RootState } from "redux/store";
import ApiService from "services/apiService";
import { CommentsEditor } from "./CommentsEditor";
import { CommentsMenu } from "./CommentsMenu";

export const Comments = (props: {
  comments: Comment[] | undefined;
  onCreateComment: (Comment: Comment) => void;
  onSaved: () => void;
}) => {
  const userId = useSelector((state: RootState) => state.app.userId);
  const [editingComment, setEditingComment] = useState<Comment | undefined>();
  const formatDateTime = useDateTime();

  const handleSend = () => {
    if (editingComment) {
      if (editingComment.id > 0) {
        ApiService.comments.saveUpdateComment(editingComment).then((response) => {
          props.onSaved();
        });
      } else {
        props.onCreateComment(editingComment);
      }
    }

    setEditingComment(undefined);
  };

  return (
    <Stack direction="column" spacing="md">
      <Stack direction="row" spacing="md" alignItems={"center"} justifyContent="space-between" width="100%">
        <Typography>{props.comments?.length} notes</Typography>
        <Button onClick={() => setEditingComment({ id: 0 } as Comment)}>+ Note</Button>
      </Stack>

      <Divider />

      <Stack direction="column">
        {props.comments?.map((comment) => (
          <Stack key={comment.id} direction="column" py={2}>
            <Stack direction="row" justifyContent={"space-between"} alignItems="center">
              <Stack direction="row" spacing="md" alignItems="center">
                {comment.createdByName && <Avatar string={comment.createdByName} />}

                <Stack direction="column">
                  <Typography fontWeight={"medium"}>{comment.createdByName}</Typography>

                  <Typography variant="caption">{formatDateTime(comment.createdDate)}</Typography>
                </Stack>
              </Stack>

              <Stack direction="row" spacing="sm" alignItems={"center"}>
                {userId === comment.createdById && !comment.isActivity && (
                  <CommentsMenu comment={comment} setEditingComment={setEditingComment} onSaved={props.onSaved} />
                )}
              </Stack>
            </Stack>

            <Stack direction="column" spacing="md" px={3} py={2}>
              <RichTextReader html={comment.message} />
            </Stack>

            <Divider />
          </Stack>
        ))}
      </Stack>

      <CommentsEditor editingComment={editingComment} setEditingComment={setEditingComment} handleSend={handleSend} />
    </Stack>
  );
};
